import type { EgsField } from './types';

export const EGS_FIELDS: Array<EgsField> = [];
